import $ from 'jquery'
import 'select2'
import 'select2/dist/css/select2.min.css'
// TODO: Fix issue. Cant load current package from git
// import 'select2-searchInputPlaceholder/select2-searchInputPlaceholder'
import jcf from 'jcf'

const customSelectPlaceholder = window ?? { SelectPlaceholder: 'Saisissez l\'aparthotel concerné'}

export const renderCustomSelect = (
  holder = document.querySelector('.select-hotel'),
) => {
  $(holder).find('.custom_select').each(function () {
    const customSelect = $(this)
    const openSameTab = customSelect.hasClass('custom-select-same-tab')

    customSelect.select2({
      dropdownAutoWidth: false,
      width: '100%',
      placeholder: customSelectPlaceholder.SelectPlaceholder,
      searchInputPlaceholder: customSelectPlaceholder.SelectPlaceholder,
    })

    // On change hotel page should be opened in a new tab or in the same tab
    customSelect.on('change', function () {
      var isCommuterForm = $(this).closest('.commuter-offer-form').length
      if (!isCommuterForm && openSameTab) {
        const link = this.value
        if (link !== '') {
          const win = window.open(link, '_self')
          win.focus()
        }
      } else if (!isCommuterForm) {
        const link = this.value
        if (link !== '') {
          const win = window.open(link, '_blank')
          win.focus()
        }
      }
    })

    customSelect.on('select2:open', () => {
      const results = customSelect.data('select2').$results

      results.addClass('jcf-scrollable')
      setTimeout(() => {
        jcf.replace(results)
      })
    })

    customSelect.on('select2:close', () => {
      jcf.destroy(customSelect.data('select2').$results)
    })
  })
}
